import React from 'react';
import clsx from "clsx";
import List from '../../List/List';

export default class RatePresenterChannels extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'channels',
      'tab-pane': true
    })

    //console.log("this.props", this.props);
    var website_items = this.props.channel_rate_room_types.filter((crrt) => {
      if (crrt.channel_name === "website") {
        return crrt
      }
    })

    var google_items = this.props.channel_rate_room_types.filter((crrt) => {
      if (crrt.channel_name === "google") {
        return crrt
      }
    })

    return(
      <div className={tabClasses} id="channels">
        <div className="row">
          <div className="col-md-6">
            <div className="panel panel-default">
              <div className="panel-body container">
                <h3 className="panel-heading-text">{I18n.t("website")}</h3>
                <div className="row">
                  <div className="col-md-12">
                    { website_items &&  website_items.length
                    ?
                      <List
                        header_primary="room_type_name"
                        header_secondary="status"
                        items={website_items}
                        display_column_primary="room_type_name"
                        display_column_secondary="status"
                        keyString= 'room_type_name'
                        />
                    :
                      <div className="no-records">
                        <span className="none">{I18n.t('none')}</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="panel panel-default">
              <div className="panel-body container">
                <h3 className="panel-heading-text">{I18n.t("google")}</h3>
                <div className="row">
                  <div className="col-md-12">
                    { google_items && google_items.length
                    ?
                    <List
                      header_primary="room_type_name"
                      header_secondary="status"
                      items={google_items}
                      display_column_primary={"room_type_name"}
                      display_column_secondary="status"

                      />
                    :
                      <div className="no-records">
                        <span className="none">{I18n.t('none')}</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}
